import { pics } from '@ifeng-fe/three_terminal/es/mobile/pics';
import type { ImageInitialModel } from '@src/utils/formatImage';

export const showPic = ({ images, index }: { images: ImageInitialModel[]; index: number }) => {
    const list = images.map((item) => {
        const { initialUrl, initialWidth, initialHeight } = item;

        return { url: initialUrl, width: initialWidth, height: initialHeight };
    });

    pics.show({
        list,
        current: index,
    });
};
